import { Box } from '../Box';

export const MastheadOverlay = () => {
  return (
    <Box className="absolute top-0 left-0 flex w-full h-full text-white bg-black bg-opacity-25" />
  );
};
